var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-dialog",
    {
      ref: "dialog",
      attrs: {
        "store-modal": "",
        color: "secondary",
        width: "600px",
        icon: _vm.generateMessagePath("icon"),
        title: _vm.generateMessagePath("title")
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function() {
            return [
              _c(
                "v-btn",
                {
                  staticClass: "mr-5",
                  attrs: {
                    disabled: !_vm.valid,
                    small: "",
                    color: "success",
                    loading: _vm.isEditing
                      ? _vm.isLoadingUpdate
                      : _vm.isLoadingCreate
                  },
                  on: { click: _vm.handleValidateClick }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.generateMessagePath("validate")) +
                      "\n    "
                  )
                ]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          on: {
            input: function($event) {
              return _vm.$emit("valid", _vm.valid)
            }
          },
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          outlined: "",
                          dense: "",
                          items: _vm.types,
                          "item-text": "name",
                          "item-value": "id",
                          rules: [
                            v =>
                              !!v ||
                              _vm.generateMessage(
                                "user_exchanges.create.notype"
                              )
                          ],
                          label:
                            _vm.generateMessage("user_exchanges.create.type") +
                            " *",
                          required: ""
                        },
                        model: {
                          value: _vm.item.exchange_type,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "exchange_type", $$v)
                          },
                          expression: "item.exchange_type"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Date",
                          dense: "",
                          "hide-details": "",
                          outlined: "",
                          type: "datetime-local",
                          min: "2010-06-07T00:00"
                        },
                        model: {
                          value: _vm.item.datetime,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "datetime", $$v)
                          },
                          expression: "item.datetime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("custom-authors-selector", {
                        attrs: {
                          placeholder: _vm.generateMessage(
                            "user_exchanges.create.author"
                          )
                        },
                        model: {
                          value: _vm.item.author_idx,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "author_idx", $$v)
                          },
                          expression: "item.author_idx"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("custom-text-area", {
                        attrs: {
                          label: _vm.generateMessage(
                            "user_exchanges.create.description"
                          )
                        },
                        model: {
                          value: _vm.item.description,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "description", $$v)
                          },
                          expression: "item.description"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        { on: { click: _vm.handleAddLogbookLinkClick } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.generateMessage(
                                  `user_exchanges.${
                                    _vm.item.logbook_entry_id
                                      ? "update"
                                      : "create"
                                  }.logbook`
                                )
                              ) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.item.logbook_entry_id) +
                          "\n          "
                      ),
                      _c(
                        "v-dialog",
                        {
                          attrs: {
                            fullscreen: "",
                            "overlay-color": "white",
                            transition: "dialog-bottom-transition",
                            scrollable: ""
                          },
                          model: {
                            value: _vm.dialog,
                            callback: function($$v) {
                              _vm.dialog = $$v
                            },
                            expression: "dialog"
                          }
                        },
                        [
                          _c("user-exchange-form-link-logbook", {
                            attrs: { value: _vm.item.logbook_entry_id },
                            on: {
                              input: _vm.handleLogbookItemSelected,
                              close: _vm.handleClose
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }